import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import getAxiosInstance, { getConfig, getUrl } from '../AxiosSetup';

export interface FeedbackRequestState {
  status: 'idle' | 'loading' | 'failed' | 'success';
  data: any;
}

const initialState: FeedbackRequestState = {
  status: 'idle',
  data: null,
};

export const postFeedbackRequest = createAsyncThunk(
  'Post Feedback Request',
  async (applicationId: string, { rejectWithValue }) => {
    const axios = getAxiosInstance();
    try {
      const response = await axios.post(
        getUrl('checklist/send-feedback-request', { query: { applicationId } }),
        {},
        getConfig(true),
      );
      return response.data;
    } catch (e: any) {
      if (!e.response) {
        throw e;
      }
      return rejectWithValue(e.response.data);
    }
  },
);

export const PostFeedbackRequestSlice = createSlice({
  name: 'Post Feedback Request',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postFeedbackRequest.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(postFeedbackRequest.fulfilled, (state, action) => {
        state.status = 'success';
        state.data = action.payload;
      })
      .addCase(postFeedbackRequest.rejected, (state, action) => {
        state.status = 'failed';
        state.data = action.payload;
      });
  },
});

export const selectPostFeedbackRequestLoading = (state: RootState) =>
  state.postFeedbackRequest.status;
export const selectPostFeedbackRequestData = (state: RootState) => state.postFeedbackRequest.data;

export default PostFeedbackRequestSlice.reducer;
